export const roomConfigButtonStyles = {
        topRight: [
            'wb-top-left-r',
            'wb-bot-left-r',
            'wb-bot-right-r',
        ],
        centerLeft: [
            'wb-top-right-r',
            'wb-bot-right-r',
        ],
        centerRight: [
            'wb-top-left-r',
            'wb-bot-left-r',
        ],
        bottomLeft: [
            'wb-top-left-r',
            'wb-top-right-r',
            'wb-bot-right-r',
        ],
        bottomCenter: [
            'wb-top-left-r',
            'wb-top-right-r',
        ],
        bottomRight: [
            'wb-top-left-r',
            'wb-top-right-r',
            'wb-bot-left-r',
        ],
        backRightWall: [
            'wb-top-left-r',
            'wb-top-right-r',
            'wb-bot-left-r',
            'wb-bot-right-r',
        ],
    };
